import { Button, colors, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Listing, MonoText } from "components";
import RenderGuard from "components/RenderGuard";
import moment from "moment";
import PropTypes from 'prop-types';
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import capitalise from "utils/capitalise";
import Currency from "utils/currency";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  light_text: {
    fontWeight: "bold",
    opacity: .5,
    fontStyle: "italic"
  },
  red: {
    color: colors.red[500],
  },
  green: {
    color: colors.green[500],
  }
}));

const Results = props => {
  const { title, className, models, filter, loading, onPageChange, ...rest } = props;

  const classes = useStyles();

  return (
    <Listing
      title={title}
      onPageChange={onPageChange}
      loading={loading}
      filter={filter}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Time</TableCell>
            <TableCell>Remarks</TableCell>
            <TableCell>Amount</TableCell>
            <RenderGuard renderIf={!filter.wallet}>
              <TableCell align="right">Actions</TableCell>
            </RenderGuard>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map(model => (
            <TableRow hover key={model.id}>
              <TableCell>
                <MonoText>{moment(model.created_at).format("DD/MM/YYYY - HH:mm")}</MonoText>
                <div><Typography variant="caption">{model.reference}</Typography></div>
              </TableCell>
              <TableCell>
                {capitalise(model.remarks)}
              </TableCell>
              <TableCell>
                <Typography variant="h5" className={model.amount >= 0 ? classes.green : classes.red}>{Currency.compress(model.amount, model.currency)}</Typography>
                <div><Typography variant="caption">{model.currency}</Typography></div>
              </TableCell>
              <RenderGuard renderIf={!filter.wallet}>
                <TableCell align="right">
                  <Button color="primary" component={RouterLink} size="small" to={`/wallets/${model.wallet_id}/summary`} variant="outlined">
                    View Wallet
                </Button>
                </TableCell>
              </RenderGuard>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Listing >
  );
};

Results.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  models: PropTypes.array.isRequired
};

Results.defaultProps = {
  loading: false,
  onPageChange: () => { },
  models: [],
  filter: {}
};

export default Results;
